<i class="fa-solid fa-xmark popup-closer" (click)="store.closePopup()"></i>

@if (holePopup(); as popup) {
  <h4 class="popup-title">{{ truncate(popup.blastName) }}</h4>

  <div class="popup-body">
    <div>
      <p><strong>{{ 'HOLE.NAME' | translate }}:</strong> {{ popup.hole.name }}</p>
      @if (popup.hole.plannedGeometry?.length) {
        <p><strong>{{ 'HOLE.PLAN_DEPTH' | translate }}:</strong> {{ popup.hole.plannedGeometry.length | number: '1.0-2' }} m</p>
      }
      @if (popup.hole.measuredGeometry?.length) {
        <p><strong>{{ 'HOLE.MEASURED_DEPTH' | translate }}:</strong> {{ popup.hole.measuredGeometry.length | number: '1.0-2' }} m</p>
      }
      @if (popup.hole.plannedGeometry?.diameter) {
        <p><strong>{{ 'HOLE.DIAMETER' | translate }}:</strong> {{ popup.hole.plannedGeometry.diameter * 1000 | number: '1.0-2' }} mm</p>
      }
    </div>

    @if (popup.details?.Loading?.actualCharge; as charge) {
      <div>
        @if (charge.totalBulk) {
          <p><strong>{{ 'HOLE.MEASUREDBULK' | translate }}:</strong> {{ charge.totalBulk | number: '1.0-2' }} kg</p>
        }
        @if (charge.totalCartridges) {
          <p><strong>{{ 'HOLE.MEASUREDCARTRIDGE' | translate }}:</strong> {{ charge.totalCartridges | number: '1.0-2' }}</p>
        }
      </div>
    }

    @if (popup.hole.status) {
      <div>
        <p><strong>{{ 'GLOBAL.STATUS' | translate }}:</strong> {{ 'HOLE.' + popup.hole.status | translate }}</p>
      </div>
    }
  </div>

  @if (showDetailsLink()) {
    <div class="popup-footer">
      <a href="" [title]="'HOLE.DETAILS' | translate" (click)="onOpenBlast($event)">{{ 'HOLE.DETAILS' | translate }}</a>
    </div>
  }
} @else {
  <h4 class="popup-title">{{ truncate(blast()?.nom) }}</h4>

  <div class="popup-body">
    @if (blast()?.dateTirPrevisionnelle || blast()?.dateTirEffective) {
      <div>
        @if (blast()?.dateTirPrevisionnelle) {
          <p><strong>{{ 'TIR.DATE_PREV' | translate }} :</strong> {{ blast()?.dateTirPrevisionnelle | date: 'dd/MM/yyyy' }}</p>
        }
        @if (blast()?.dateTirEffective) {
          <p><strong>{{ 'TIR.DATE_EFF' | translate }} :</strong> {{ (blast()?.dateTirEffective | date: 'dd/MM/yyyy H') + 'h' }}</p>
        }
      </div>
    }

    @if (blast()?.nomZone || blast()?.niveau) {
      <div>
        @if (blast()?.nomZone) {
          <p><strong>{{ 'GLOBAL.ZONE' | translate }} :</strong> {{ blast()?.nomZone }}</p>
        }
        @if (blast()?.niveau) {
          <p><strong>{{ 'GLOBAL.NIVEAU' | translate }} :</strong> {{ blast()?.niveau }}</p>
        }
      </div>
    }

    @if (selectedKpi(); as kpi) {
      <div>
        <p><strong>{{ 'KPI.KPI_SELECTIONNE' | translate }} :</strong> {{ kpi.name }} : {{ kpi.value }} {{ kpi.unit }}</p>
      </div>
    }

    @if (configuredKpis().length) {
      <div>
        @for (kpi of configuredKpis(); track $index) {
          <p><strong>{{ kpi.name }} :</strong> {{ kpi.value }} {{ kpi.unit }}</p>
        }
      </div>
    }
  </div>

  @if (showDetailsLink() && blast()) {
    <div class="popup-footer">
      <a href="" [title]="'TIR.DETAILS' | translate" (click)="onOpenBlast($event)">{{ 'TIR.DETAILS' | translate }}</a>
    </div>
  }
}
